import { Injectable } from '@angular/core';
import { BaseAPIClass } from '@app/core/class/baseAPI.class';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { environment } from '@env/environment.prod';
import { Paginated } from '../model/paginated.model';
import { Warehouse } from '../model/warehouse.model';
import { Observable } from 'rxjs';

@Injectable()
export class WarehouseService extends BaseAPIClass {
  public isLoading = false;

  baseUrl = environment.serverBaseUrl;
  private almacenSearchUrl = this.baseUrl + '/almacen/search?term=';

  constructor(protected httpClient: HttpClient, handler: HttpBackend) {
    super(httpClient);
    this.httpClient = new HttpClient(handler);
    this.baseUrl = this.baseUrl + '/almacen';
  }

  buscarTotal(id: any): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + '/comprobante/' + id);
  }

  getAlmacen(): Promise<Paginated> {
    this.isLoading = true;
    return this.httpClient
      .get(this.baseUrl)
      .toPromise()
      .then(response => {
        this.isLoading = false;
        return response as Paginated;
      })
      .catch(this.handleError);
  }

  getMovimientosProducto(id: number): Observable<Warehouse[]> {
    return this.httpClient.get<Warehouse[]>(this.baseUrl + '/producto/' + id);
  }

  getAlmacenAtUrl(url: string): Promise<Paginated> {
    this.isLoading = true;
    return this.httpClient
      .get(url)
      .toPromise()
      .then(response => {
        this.isLoading = false;
        return response as Paginated;
      })
      .catch(this.handleError);
  }

  getAlmacenAtUrl2(pagenumber: number): Promise<Paginated> {
    this.isLoading = true;
    return this.httpClient
    .get(this.baseUrl + "?page="+pagenumber)
      .toPromise()
      .then(response => {
        this.isLoading = false;
        return response as Paginated;
      })
      .catch(this.handleError);
  }

  search(term: string): Promise<Paginated> {
    this.isLoading = true;
    return this.httpClient
      .get(`${this.almacenSearchUrl}${term}`)
      .toPromise()
      .then(response => {
        this.isLoading = false;
        return response as Paginated;
      })
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    // this.isLoading = false;
    return Promise.reject(error.message || error);
  }
}
